import React from "react";
import { LibraryPrivacy } from "@growth-machine-llc/stridist-api-client";
import { AllOption, LibraryPrivacyFilter } from "../../constants";
import { CoachLibraryHeader } from "../library/CoachLibraryHeader";
import { CoachLibraryHeaderFiltersBaseProps } from "../exercise-library/CoachExerciseLibraryHeaderFilters";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const ProgramTemplatePrivacyOptions = (isTeamAccount: boolean) => [
  {
    value: AllOption,
    tooltip: "All program templates",
    label: "All",
  },
  {
    value: LibraryPrivacy.PRIVATE,
    tooltip: "Private program templates",
    label: "Private",
  },
  ...(isTeamAccount
    ? [
        {
          value: LibraryPrivacy.TEAM,
          tooltip: "Team program templates",
          label: "Team",
        },
      ]
    : []),
  {
    value: LibraryPrivacy.PUBLIC,
    tooltip: "Public program templates",
    label: "Public",
  },
];

export interface CoachProgramLibraryHeaderFiltersProps
  extends CoachLibraryHeaderFiltersBaseProps {
  showFilterByType?: boolean;
}

export function CoachProgramLibraryHeaderFilters(
  props: CoachProgramLibraryHeaderFiltersProps,
) {
  const {
    className,
    query,
    onChangeQuery,
    privacy,
    onChangePrivacy,
    defaultQuery,
    disabledResetButton,
    onResetFilters,
    showResetButton,
    showFilterByType,
  } = props;

  const { isTeamAccount } = useCurrentUser();

  const handlePrivacyChange = React.useCallback(
    (value: LibraryPrivacyFilter) => {
      onChangePrivacy?.(value);
    },
    [onChangePrivacy],
  );

  return (
    <CoachLibraryHeader<LibraryPrivacyFilter>
      className={className}
      query={query}
      defaultQuery={defaultQuery}
      searchPlaceholder="Search by name"
      onChangeQuery={onChangeQuery}
      toggleOptions={
        showFilterByType
          ? ProgramTemplatePrivacyOptions(isTeamAccount)
          : undefined
      }
      toggleValue={privacy}
      onChangeToggle={handlePrivacyChange}
      showResetButton={showResetButton}
      disabledResetButton={disabledResetButton}
      onResetFilters={onResetFilters}
    />
  );
}
